import { Tag, Tooltip } from "antd";

// The lists' "Created via" filter: `createdVia=ai` shows the drafts an AI
// assistant made that nobody has published or discarded yet. Publication and
// discard clear the marker, so a published item carries neither this label
// nor a match for the filter.
export const CREATED_VIA_FILTER = { name: "Created via", id: "createdVia", children: [{ id: "ai", name: "AI" }] };

// The API supplies provenance for the editable draft, not the published row.
// Keep client/author text as React text; never render it as markup.
export default function AiDraftLabel({ record }) {
  if (!record?.createdViaClient) return null;
  const author = record.createdViaAuthorName || record.User?.fullName;
  return (
    <div style={{ marginTop: 4, display: "flex", alignItems: "center", flexWrap: "wrap", gap: 4 }}>
      <Tooltip title={`Created via AI: ${record.createdViaClient}`}>
        <Tag color="purple" style={{ marginInlineEnd: 0 }}>Created via AI</Tag>
      </Tooltip>
      {author ? <span>{author}</span> : null}
    </div>
  );
}
